import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  EParamChannelTypeGlobal,
  EParamInventoryTypeGlobal,
  EReportColumnHeader,
  IReportingAdGroupsTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAdGroupsPositionsReportTableFilters,
  TDAAdGroupsReportTableFilters,
  TDOOHAdGroupsReportTableFilters,
  TDOOHAdGroupsScreensReportTableFilters,
  TGenericAdGroupsCategoriesReportTableFilters,
  TGenericAdGroupsKeywordsReportTableFilters,
  TGenericAdGroupsReportTableFilters,
  TPPAdvertiserId,
  TSPAdGroupsReportTableFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetAdvertiserReportingAdGroupsTableV3({
  advertiserId,
  retailerId,
  inventoryType,
  campaignId,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  channelType,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (
  | TGenericAdGroupsReportTableFilters
  | TGenericAdGroupsCategoriesReportTableFilters
  | TGenericAdGroupsKeywordsReportTableFilters
  | TSPAdGroupsReportTableFilters
  | TDAAdGroupsReportTableFilters
  | TDAAdGroupsPositionsReportTableFilters
  | TDOOHAdGroupsReportTableFilters
  | TDOOHAdGroupsScreensReportTableFilters
) &
  TPPAdvertiserId): UseQueryResult<
  AxiosResponse<IReportingAdGroupsTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getAdvertiserReportingAdGroupsTable_${inventoryType}_${advertiserId}_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, inventoryType }],
    () => {
      return coreAPIV3.advertiserReporting().getAdvertiserAdGroupsReportTableV3(
        advertiserId,
        generateCorrelationId(),
        retailerId,
        campaignId,
        inventoryType as EParamInventoryTypeGlobal,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status,
        channelType as EParamChannelTypeGlobal | undefined
      )
    },
    { suspense, enabled }
  )
}
